import React, { FC } from 'react'
import { getBasicPageMetaData, Seo } from '@/layout/Seo'
import { useLocale } from '@/utils/LocaleUtil'
import { useTranslate } from '@/utils/translate/translate-client'
import { useGiveawayContext } from '../../context/GiveawayContext'

export const GiveawaySeo: FC = () => {
  const { content, sweepstake, theatricalSlug } = useGiveawayContext()
  const { locale } = useLocale()
  const { t } = useTranslate('tickets')

  const { projectName } = sweepstake
  const { seoImageUrl } = content

  const title = t('giveawaySeoTitleAngel', 'PRE-ORDER {{projectName}} Tickets | Angel', {
    projectName,
  })

  const description = t('giveawaySeoDescription', 'Buy {{projectName}} tickets for a Chance to Win the Giveaway!', {
    projectName,
  })

  return (
    <Seo
      {...getBasicPageMetaData({
        cloudinaryImagePath: seoImageUrl ?? '',
        cloudinaryTransformation: 'b_rgb:000000,c_fill',
        title,
        description,
        locale,
        path: `/giveaway/${theatricalSlug}`,
      })}
    />
  )
}
